'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { customRichTextTags } from '@/utils/i18n';

import { CardBack } from './card-back';
import { CardFront } from './card-front';
import { FlipCard } from './flip-card';
import type { Product, ProductKey } from './products';

// 모바일 카드: '검사 장점 보기' 버튼으로 뒷면을, 뒷면 아이콘/빈 배경 탭으로 앞면을 연다.
// 이동은 캐러셀 스와이프/화살표가 담당하므로 카드 자체엔 클릭 핸들러가 없다.
export function MobileCard({
  product,
  interactive = true,
}: {
  product: Product;
  interactive?: boolean;
}) {
  const t = useTranslations('Products.solutionFinder');
  const p = `products.${product.key}` as `products.${ProductKey}`;

  const [flipped, setFlipped] = useState(false);
  const flipToggle = () => setFlipped(f => !f);

  return (
    <FlipCard
      flipped={flipped}
      interactive={interactive}
      // 화면에 안 보이는 면을 SR·탭 순서에서 제외
      frontHidden={flipped}
      backHidden={!flipped}
      front={
        <CardFront
          product={product}
          onFlip={flipToggle}
          buttonTabIndex={flipped ? -1 : 0}
          viewBenefitsLabel={t('viewBenefits')}
          question={t.rich(`${p}.question`, customRichTextTags)}
          name={t(`${p}.name`)}
          description={t.rich(`${p}.description`, customRichTextTags)}
        />
      }
      back={
        <CardBack
          name={t(`${p}.name`)}
          benefits={t.raw(`${p}.benefits`) as string[]}
          learnMore={t('learnMore')}
          flipBackLabel={t('flipBack')}
          contentTabIndex={flipped ? 0 : -1}
          href={product.href}
          trackSlug={product.key}
          onFlipBack={flipToggle}
        />
      }
    />
  );
}
